/**
 * WonTotalsRow.jsx - the "won totals" row of the Projects table.
 *
 * Rendered TWICE from ProjectsView (pinned under the sticky header, and again
 * as the last row) so the totals read without scrolling a several-hundred-row
 * list - one component so the two copies can never drift apart.
 *
 * Since 10/9/26 it follows the person's columns (tableViews/TotalsRow.jsx):
 * `cols` are the cells on screen in order, and a total shows only while its
 * column does. With every column showing it is the layout it always had:
 * the label over Quote Date -> REV, Quoted, COGS, Profit, Margin, Invoiced
 * and Leftover under their columns, the invoice group tinted.
 */
import { MarginPill } from '../ui';
import { fmt } from '../../utils/format';
import TotalsRow from '../tableViews/TotalsRow';

const TOTALS_BG_INVOICE = '#FFFBEB'; // invoice-group tint (unchanged)
const TOTALS_BG_LEFTOVER = '#FEF3C7'; // amber leftover tint (unchanged)
const BAR_AMBER = { color: '#FFD54F', fontWeight: 800, fontSize: '12.5px' };
const FILLS = { latestInvoiceDate: TOTALS_BG_INVOICE, invoiceNumbers: TOTALS_BG_INVOICE };

function WonTotalsRow({ totals, cols, stickyTop, rowRef, money = fmt }) {
  // `money`: the KSA screen passes its SAR formatter
  const cells = {
    quotedPrice: { content: money(totals.sumPrice) },
    cogs: { content: money(totals.sumCogs) },
    profit: { content: money(totals.profit) },
    margin: { content: <MarginPill value={totals.margin} />, className: '' },
    invoicedAlready: { content: totals.sumInvoiced ? money(totals.sumInvoiced) : '-', bg: TOTALS_BG_INVOICE },
    moneyLeftover: {
      content: totals.sumLeftOver ? money(totals.sumLeftOver) : '-',
      className: 'text-amber-800',
      bg: TOTALS_BG_LEFTOVER,
      accent: BAR_AMBER,
    },
  };
  const shown = Object.fromEntries(Object.entries(cells).filter(([c]) => cols.includes(c)));
  return (
    <TotalsRow
      cols={cols}
      cells={shown}
      fills={FILLS}
      label={{ title: stickyTop != null ? 'Won Totals' : 'Won totals', count: totals.count }}
      stickyTop={stickyTop}
      rowRef={rowRef}
    />
  );
}

export default WonTotalsRow;
